import React, { useEffect } from "react";
import {
  Container,
  VStack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Button,
  HStack,
  Heading,
  Flex,
  Box,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAdmin } from "../../context/AdminContext";
import AdminMessages from "./AdminMessages";
import AdminNewsList from "./AdminNewsList";

const AdminMain = () => {
  const colors = {
    teal: "#1da179",
    tealLight: "#34c49b",
    grayBg: "#f9f9f9",
  };

  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const { isAdmin, logout } = useAdmin();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin) {
      navigate("/admin/login");
    }
  }, [isAdmin, navigate]);

  return (
    <VStack py={10} spacing={6} minH="100vh" bg={colors.grayBg}>
      <Container
        maxW="7xl"
        bg="white"
        p={{ base: 6, md: 10 }}
        borderRadius="2xl"
        boxShadow="2xl"
      >
        {/* HEADER */}
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align={{ base: "flex-start", md: "center" }}
          gap={4}
          mb={8}
        >
          <Heading
            color={colors.teal}
            textAlign={{ base: "center", md: "left" }}
            size="lg"
            fontWeight="bold"
          >
            {isArabic ? "أهلاً بك" : "Welcome, Admin"}
          </Heading>
          <Button
            onClick={logout}
            bg="red.500"
            color="white"
            _hover={{ bg: "red.600" }}
            size="sm"
          >
            {isArabic ? "تسجيل الخروج" : "Logout"}
          </Button>
        </Flex>

        {/* TABS */}
        <Tabs variant="enclosed" colorScheme="teal">
          <TabList borderBottom={`2px solid ${colors.teal}33`}>
            <HStack spacing={4}>
              <Tab
                _selected={{
                  bg: colors.teal,
                  color: "white",
                  borderColor: colors.teal,
                }}
                borderRadius="md"
                fontWeight="semibold"
              >
                {isArabic ? "إدارة الرسائل" : "Messages Management"}
              </Tab>
              <Tab
                _selected={{
                  bg: colors.teal,
                  color: "white",
                  borderColor: colors.teal,
                }}
                borderRadius="md"
                fontWeight="semibold"
              >
                {isArabic ? "إدارة الأخبار" : "News Management"}
              </Tab>
            </HStack>
          </TabList>

          <TabPanels mt={6}>
            <TabPanel>
              <Box borderRadius="lg" p={4} bg={colors.grayBg}>
                <AdminMessages />
              </Box>
            </TabPanel>
            <TabPanel>
              <Box borderRadius="lg" p={4} bg={colors.grayBg}>
                <AdminNewsList />
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Container>
    </VStack>
  );
};

export default AdminMain;
